import React, { useState, useEffect,useRef } from "react";
import axios from "axios";
import { ConfigToken } from "../Auth/ConfigToken";
import { base_url } from "../Auth/BackendAPIUrl";
import { Footer } from "../Common/Footer/Footer";
import { Navbar } from "../Common/Navbar/Navbar";
import { format } from "date-fns";
import tickCircleIcon from "../../Images/tickCircleIcon.svg";
import checkboxIcon from "../../Images/Checkboxicon.svg";
import starIcon from "../../Images/starIcon.svg";
import backIcon from "../../Images/backIcon.svg";
import uploadIcon from "../../Images/uploadIcon.svg";
import { useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Bgloader } from "../Common/Background/Bgloader";
// import { toast, ToastContainer } from "react-toastify";
import toast, { Toaster } from "react-hot-toast";
import BundlOrder from "./Order/Bundl";
import Addons from "./Order/Addons";
import { processArabicText } from "../Utils/arabicFontParenthesisChecker";
import { useNavigate } from "react-router-dom";
import "../../Components/Common/Background/Bgloader";
import Loader from "../../Images/Home/load sticker.png";
import ourWorkBranding from "../../Images/ourWorkBranding.gif";

let newToastId = null;

export default function UploadContent({ lang, setLang }) {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const [loading, setLoading] = useState(false);
  const [uploadContent, setUploadContent] = useState({});
  const [designQuestions, setDesignQuestions] = useState([]);
  const [skipId, setSkipId] = useState([]);
  const [showDetails, setDetails] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 475);
  const [isSaveAndNext, setIsSaveAndNext] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [activeItemId, setActiveItemId] = useState(null);
  const [order, setOrder] = useState(null);
  const hasInitializedFirstItem = useRef(false);
  const getOrderDetails = async () => {
    const response = await axios.get(
      `${base_url}/api/order/${orderId}/`,
      ConfigToken()
    );
    if (response.data) {
      setOrder(response.data.data);
      setDesignQuestions(response.data.design_question);
      return response.data; // Return data for immediate use
    }
    return null;
  };

  useEffect(() => {
    getOrderDetails();
  }, []);

  useEffect(() => {
    if (localStorage.getItem(orderId)) {
      const data = JSON.parse(localStorage.getItem(orderId));
      console.log(data);
      setUploadContent(data?.answers);
    } else {
      setUploadContent({});
    }
  }, [orderId]);

  // Set the first non-completed item as active on initial load
  useEffect(() => {
    if (order && order.item_details && !hasInitializedFirstItem.current) {
      // Use findFirstPendingItem helper to get the first incomplete item
      const firstPendingItemId = findFirstPendingItem(order);
      console.log('🔍 First pending item found:', firstPendingItemId, 'for order:', order.id);
      if (firstPendingItemId) {
        setActiveItemId(firstPendingItemId);
        hasInitializedFirstItem.current = true;
      } else {
        console.warn('⚠️ No pending item found - all items may be completed');
        hasInitializedFirstItem.current = true; // Mark as initialized even if no item found
      }
    }
  }, [order]);

  let [uploadFiles, setUploadFiles] = useState([]);

  // const uploadFile = async (e, id, field, name, idx) => {
  //   if (e.target.files.length) {
  //     const formData = new FormData();
  //     formData.append("file", e.target.files[0]);
  //     formData.append("file_name", e.target.files[0]?.name);

  //     try {
  //       const response = await axios.post(
  //         `${base_url}/api/upload_file/`,
  //         formData,
  //         ConfigToken()
  //       );
  //       const fileName = e.target.files[0]?.name || "";
  //       setUploadFiles((prev) => {
  //         const existing = prev.find((file) => file.id === id);
  //         if (existing) {
  //           return prev.map((file) =>
  //             file.id === id
  //               ? {
  //                   ...file,
  //                   url: [...existing.url, response.data.file_url],
  //                   name: [
  //                     ...(Array.isArray(file.name) ? file.name : [file.name]),
  //                     fileName,
  //                   ],
  //                 }
  //               : file
  //           );
  //         } else {
  //           return [
  //             ...prev,
  //             {
  //               id,
  //               url: [response.data.file_url],
  //               name: [fileName],
  //             },
  //           ];
  //         }
  //       });
  //       const docId = id.split("_")[0];
  //       setUploadContent((prev) => {
  //         const existing = prev[docId]?.[idx] || {};
  //         return {
  //           ...prev,
  //           [docId]: {
  //             ...prev[docId],
  //             [idx]: {
  //               ...existing,
  //               ...(field === "file" && {
  //                 file_url: [
  //                   ...(existing.file_url || []),
  //                   response.data.file_url,
  //                 ],
  //                 filename: e.target.files[0]?.name || "",
  //               }),
  //               item_sub_name: name,
  //             },
  //           },
  //         };
  //       });
  //     } catch (error) {
  //       console.error("Upload failed", error);
  //     }
  //     e.target.value = "";
  //   }
  // };

  const uploadFile = async (e, id, field, name, idx) => {
  const files = Array.from(e.target.files);
  if (!files.length) return;

  setIsUploading(true);
  const uploadedUrls = [];
  const uploadedNames = [];

  for (const file of files) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("file_name", file.name);

    try {
      const response = await axios.post(
        `${base_url}/api/upload_file/`,
        formData,
        ConfigToken()
      );

      uploadedUrls.push(response.data.file_url);
      uploadedNames.push(file.name);

      const docId = id.split("_")[0];
      
      // 🔥 FIXED: Update uploadContent with proper structure for validation
      setUploadContent((prev) => {
        const existing = prev[docId]?.[idx] || {};
        return {
          ...prev,
          [docId]: {
            ...prev[docId],
            [idx]: {
              ...existing,
              
              // Keep your existing file fields
              ...(field === "file" && {
                file_url: [
                  ...(existing.file_url || []),
                  response.data.file_url,
                ],
                filename: file.name,
              }),
              item_sub_name: name,
              
              // 🔥 ADD these for better tracking
              hasFiles: true,
              fileCount: (existing.file_url?.length || 0) + 1,
            },
          },
        };
      });

   

    } catch (error) {
      console.error("Upload failed", error);
    }
  }

  // Keep your existing uploadFiles update
  setUploadFiles((prev) => {
    const existing = prev.find((file) => file.id === id);
    if (existing) {
      return prev.map((file) =>
        file.id === id
          ? {
              ...file,
              url: [...existing.url, ...uploadedUrls],
              name: [
                ...(Array.isArray(file.name) ? file.name : [file.name]),
                ...uploadedNames,
              ],
            }
          : file
      );
    } else {
      return [
        ...prev,
        {
          id,
          url: uploadedUrls,
          name: uploadedNames,
        },
      ];
    }
  });

  setIsUploading(false);
  e.target.value = "";
};


  const colors = {
    12: "#f175ad",
    4: "#1BA56F",
    22: "#00A8C8",
    13: "#f175ad",
  };

  const [themeColor, setThemeColor] = useState("#000");

  useEffect(() => {
    setThemeColor("#1BA56F");
  }, [order]);

 const toastMessage = () => {
  const message = lang === "ar" ? "تم حفظ المحتوى بنجاح" : "Content saved successfully!";

  if (newToastId) {
    toast.dismiss(newToastId);
  }

  newToastId = toast(message, {
    duration: 3000,
    style: {
      color: themeColor,
      border: `1px solid ${themeColor}`,
      fontWeight: "700",
      background: "#fff",
      boxShadow: "none",
      borderRadius: "0px",
    },
  });
};

const toastErrorMessage = (msg) => {
  const message = lang === "ar"
    ? msg || "حدث خطأ. يرجى المحاولة مرة أخرى."
    : msg || "Something went wrong. Please try again.";

  if (newToastId) {
    toast.dismiss(newToastId);
  }

  newToastId = toast(message, {
    duration: 3000,
    style: {
      color: "#D83D99",
      border: `1px solid #D83D99`,
      fontWeight: "700",
      background: "#fff",
      boxShadow: "none",
      borderRadius: "0px",
    },
  });
};

  // Helper function to find the next pending item with specific order data
  const findNextPendingItemWithOrder = (currentItemId, orderData) => {
    if (!orderData) return null;

    // Parse current itemId (format: "itemId_qty")
    const [currentItemIdNum, currentQty] = currentItemId.toString().split('_').map(Number);
    
    // First, check if there are more quantities for the current item
    const currentBundleItem = orderData.item_details?.bundle_items?.find(
      (item) => item.id === currentItemIdNum && item.item__id !== 76 && (item.status === "in process" || item.status === "pending_content")
    );
    
    if (currentBundleItem) {
      // Check if there are more quantities for this item
      const nextQty = Array.from(
        { length: currentBundleItem.qty },
        (_, i) => i + 1
      ).find((qty) => qty > currentQty && !currentBundleItem.uploaded_qty?.includes(qty));
      
      if (nextQty) {
        return `${currentBundleItem.id}_${nextQty}`;
      }
    }

    const currentAddonItem = orderData.item_details?.addon_items?.find(
      (item) => item.id === currentItemIdNum && (item.status === "in process" || item.status === "pending_content")
    );
    
    if (currentAddonItem) {
      // Check if there are more quantities for this item
      const nextQty = Array.from(
        { length: currentAddonItem.qty },
        (_, i) => i + 1
      ).find((qty) => qty > currentQty && !currentAddonItem.uploaded_qty?.includes(qty));
      
      if (nextQty) {
        return `${currentAddonItem.id}_${nextQty}`;
      }
    }

    // If no more quantities for current item, find next item
    // Check remaining bundle items
    const remainingBundleItems = orderData.item_details?.bundle_items?.filter(
      (item) => item.item__id !== 76 && (item.status === "in process" || item.status === "pending_content")
    ) || [];
    
    for (const bundleItem of remainingBundleItems) {
      if (bundleItem.id > currentItemIdNum) {
        const firstNonUploadedQty = Array.from(
          { length: bundleItem.qty },
          (_, i) => i + 1
        ).find((qty) => !bundleItem.uploaded_qty?.includes(qty));
        
        if (firstNonUploadedQty) {
          return `${bundleItem.id}_${firstNonUploadedQty}`;
        }
      }
    }

    // Check addon items
    const remainingAddonItems = orderData.item_details?.addon_items?.filter(
      (item) => item.status === "in process" || item.status === "pending_content"
    ) || [];
    
    for (const addonItem of remainingAddonItems) {
      if (addonItem.id > currentItemIdNum) {
        const firstNonUploadedQty = Array.from(
          { length: addonItem.qty },
          (_, i) => i + 1
        ).find((qty) => !addonItem.uploaded_qty?.includes(qty));
        
        if (firstNonUploadedQty) {
          return `${addonItem.id}_${firstNonUploadedQty}`;
        }
      }
    }

    // If current item was a bundle item, check addon items from start
    if (currentBundleItem) {
      const addonItem = orderData.item_details?.addon_items?.find(
        (item) => item.status === "in process" || item.status === "pending_content"
      );
      
      if (addonItem) {
        const firstNonUploadedQty = Array.from(
          { length: addonItem.qty },
          (_, i) => i + 1
        ).find((qty) => !addonItem.uploaded_qty?.includes(qty));
        
        if (firstNonUploadedQty) {
          return `${addonItem.id}_${firstNonUploadedQty}`;
        }
      }
    }

    return null;
  };

  // Helper function to find the first available pending item
  const findFirstPendingItem = (orderData) => {
    if (!orderData || !orderData.item_details) {
      console.warn('⚠️ findFirstPendingItem: orderData or item_details is missing');
      return null;
    }

    // Ensure we have valid arrays
    const bundleItems = orderData.item_details.bundle_items || [];
    const addonItems = orderData.item_details.addon_items || [];

    // Check all bundle items to find the first one with a pending quantity
    for (const bundleItem of bundleItems) {
      if (
        bundleItem &&
        bundleItem.item__id !== 76 &&
        (bundleItem.status === "in process" || bundleItem.status === "pending_content") &&
        bundleItem.qty > 0
      ) {
        // Ensure uploaded_qty is an array
        const uploadedQty = Array.isArray(bundleItem.uploaded_qty) ? bundleItem.uploaded_qty : [];
        
        // Find first non-uploaded quantity for this item
        const firstNonUploadedQty = Array.from(
          { length: bundleItem.qty },
          (_, i) => i + 1
        ).find((qty) => !uploadedQty.includes(qty));
        
        if (firstNonUploadedQty) {
          const itemId = `${bundleItem.id}_${firstNonUploadedQty}`;
          console.log('✅ Found first bundle item:', itemId);
          return itemId;
        }
      }
    }

    // If no bundle item found with pending quantities, check addon items
    for (const addonItem of addonItems) {
      if (
        addonItem &&
        (addonItem.status === "in process" || addonItem.status === "pending_content") &&
        addonItem.qty > 0
      ) {
        // Ensure uploaded_qty is an array
        const uploadedQty = Array.isArray(addonItem.uploaded_qty) ? addonItem.uploaded_qty : [];
        
        // Find first non-uploaded quantity for this item
        const firstNonUploadedQty = Array.from(
          { length: addonItem.qty },
          (_, i) => i + 1
        ).find((qty) => !uploadedQty.includes(qty));
        
        if (firstNonUploadedQty) {
          const itemId = `${addonItem.id}_${firstNonUploadedQty}`;
          console.log('✅ Found first addon item:', itemId);
          return itemId;
        }
      }
    }

    console.warn('⚠️ findFirstPendingItem: No pending items found');
    return null;
  };

  // Helper function to find the next pending item
  const findNextPendingItem = (currentItemId) => {
    if (!order) return null;

    // Parse current itemId (format: "itemId_qty")
    const [currentItemIdNum, currentQty] = currentItemId.toString().split('_').map(Number);
    
    // First, check if there are more quantities for the current item
    const currentBundleItem = order.item_details?.bundle_items?.find(
      (item) => item.id === currentItemIdNum && item.item__id !== 76 && (item.status === "in process" || item.status === "pending_content")
    );
    
    if (currentBundleItem) {
      // Check if there are more quantities for this item
      const nextQty = Array.from(
        { length: currentBundleItem.qty },
        (_, i) => i + 1
      ).find((qty) => qty > currentQty && !currentBundleItem.uploaded_qty?.includes(qty));
      
      if (nextQty) {
        return `${currentBundleItem.id}_${nextQty}`;
      }
    }

    const currentAddonItem = order.item_details?.addon_items?.find(
      (item) => item.id === currentItemIdNum && (item.status === "in process" || item.status === "pending_content")
    );
    
    if (currentAddonItem) {
      // Check if there are more quantities for this item
      const nextQty = Array.from(
        { length: currentAddonItem.qty },
        (_, i) => i + 1
      ).find((qty) => qty > currentQty && !currentAddonItem.uploaded_qty?.includes(qty));
      
      if (nextQty) {
        return `${currentAddonItem.id}_${nextQty}`;
      }
    }

    // If no more quantities for current item, find next item
    // Check remaining bundle items
    const remainingBundleItems = order.item_details?.bundle_items?.filter(
      (item) => item.item__id !== 76 && (item.status === "in process" || item.status === "pending_content") 
    ) || [];
    
    for (const bundleItem of remainingBundleItems) {
      if (bundleItem.id > currentItemIdNum) {
        const firstNonUploadedQty = Array.from(
          { length: bundleItem.qty },
          (_, i) => i + 1
        ).find((qty) => !bundleItem.uploaded_qty?.includes(qty));
        
        if (firstNonUploadedQty) {
          return `${bundleItem.id}_${firstNonUploadedQty}`;
        }
      }
    }

    // Check addon items
    const remainingAddonItems = order.item_details?.addon_items?.filter(
      (item) => item.status === "in process" || item.status === "pending_content"
    ) || [];
    
    for (const addonItem of remainingAddonItems) {
      if (addonItem.id > currentItemIdNum) {
        const firstNonUploadedQty = Array.from(
          { length: addonItem.qty },
          (_, i) => i + 1
        ).find((qty) => !addonItem.uploaded_qty?.includes(qty));
        
        if (firstNonUploadedQty) {
          return `${addonItem.id}_${firstNonUploadedQty}`;
        }
      }
    }

    // If current item was a bundle item, check addon items from start
    if (currentBundleItem) {
      const addonItem = order.item_details?.addon_items?.find(
        (item) => item.status === "in process" || item.status === "pending_content"
      );
      
      if (addonItem) {
        const firstNonUploadedQty = Array.from(
          { length: addonItem.qty },
          (_, i) => i + 1
        ).find((qty) => !addonItem.uploaded_qty?.includes(qty));
        
        if (firstNonUploadedQty) {
          return `${addonItem.id}_${firstNonUploadedQty}`;
        }
      }
    }

    return null;
  };

  // Helper function to scroll to an item
  const scrollToItem = (itemId) => {
    setTimeout(() => {
      const element = document.querySelector(`[data-item-id="${itemId}"]`);
      if (element) {
        // Check if element is already visible in viewport
        const rect = element.getBoundingClientRect();
        const isVisible = (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
        
        // Only scroll if element is not fully visible
        if (!isVisible) {
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }, 100);
  };

 const saveContent = async (itemId, idx, designId, filterIndex) => {
  console.log('🚀 FUNCTION ENTRY: saveContent called');
  console.log('📊 Arguments received:', { itemId, idx, designId, filterIndex });
 
   
  try {
    if (
      !uploadContent?.[itemId]?.[idx]?.language &&
      designQuestions[designId]?.language
    ) {
      toastErrorMessage(
        lang === "ar"
          ? "يرجى اختيار اللغة قبل الحفظ"
          : "Please choose language before saving."
      );

      return;
    }
    
    // Validate content field is required
    if (
      !uploadContent?.[itemId]?.[idx]?.content &&
      designQuestions[designId]?.content
    ) {
      toastErrorMessage(
        lang === "ar"
          ? "يرجى إضافة المحتوى قبل الحفظ"
          : "Please add content before saving.",
        {
          icon: false,
          toastId: "required-content-toast",
          style: {
            color: "#D83D99",
            fontWeight: "700",
          },
        }
      );
      return;
    }
    
    // Validate measurements selection
    if (
      !uploadContent?.[itemId]?.[idx]?.measurements &&
      designQuestions[designId]?.measurement
    ) {
      toastErrorMessage(
        lang === "ar"
          ? "يرجى إضافة المقاسات قبل الحفظ"
          : "Please add measurements before saving.",
        {
          icon: false,
          toastId: "required-value-toast3",
          style: {
            color: "#D83D99",
            fontWeight: "700",
          },
        }
      );
      return;
    }
    
    // Validate width, height, length if measurements is "Customize"
    if (
      uploadContent?.[itemId]?.[idx]?.measurements === "Customize" &&
      designQuestions[designId]?.measurement
    ) {
      const width = uploadContent?.[itemId]?.[idx]?.width;
      const height = uploadContent?.[itemId]?.[idx]?.height;
      const length = uploadContent?.[itemId]?.[idx]?.length;
      
      if (!width || width.trim() === "") {
        toastErrorMessage(
          lang === "ar"
            ? "يرجى إدخال العرض"
            : "Please enter width.",
          {
            icon: false,
            toastId: "required-width-toast",
            style: {
              color: "#D83D99",
              fontWeight: "700",
            },
          }
        );
        return;
      }
      
      if (!height || height.trim() === "") {
        toastErrorMessage(
          lang === "ar"
            ? "يرجى إدخال الارتفاع"
            : "Please enter height.",
          {
            icon: false,
            toastId: "required-height-toast",
            style: {
              color: "#D83D99",
              fontWeight: "700",
            },
          }
        );
        return;
      }
      
      if (!length || length.trim() === "") {
        toastErrorMessage(
          lang === "ar"
            ? "يرجى إدخال الطول"
            : "Please enter length.",
          {
            icon: false,
            toastId: "required-length-toast",
            style: {
              color: "#D83D99",
              fontWeight: "700",
            },
          }
        );
        return;
      }
    }

    // if (uploadContent?.[itemId][idx].file_url.length < 0) {
    //   toastErrorMessage(
    //     lang === "ar" ? "يرجى رفع المحتوى" : "Please upload the content."
    //   );
    // }
    const formData = {
      answers: {
        [itemId]: {
          [idx]: uploadContent?.[itemId]?.[idx] || {},
        },
      },

      orderId: order.id,
      status: "save_later",
    };
    setIsSaveAndNext(true);
    formData.answers[itemId][idx].file_links =
      formData.answers[itemId][idx].file_url;
    delete formData.answers[itemId][idx].file_url;
    const response = await axios.post(
      `${base_url}/api/upload_content/`,
      formData,
      ConfigToken()
    );

    // Broadened check: Now handles 200 (OK) or 201 (Created) as success
    if (response.status === 200 || response.status === 201) {
      setIsSaveAndNext(false);
      console.log("Content saved successfully!");

      // Inlined toastMessage logic here
      const message = lang === "ar" ? "تم حفظ المحتوى بنجاح" : "Content saved successfully!";

      if (newToastId) {
        toast.dismiss(newToastId);
      }

      newToastId = toast(message, {
        duration: 3000,
        style: {
          color: themeColor,
          border: `1px solid ${themeColor}`,
          fontWeight: "700",
          background: "#fff",
          boxShadow: "none",
          borderRadius: "0px",
        },
      });

      // Refresh order details to get updated uploaded_qty using existing function
      const updatedOrderData = await getOrderDetails();
      
      // Find and navigate to next pending item using updated order data
      if (updatedOrderData?.data) {
        let nextItemId = findNextPendingItemWithOrder(itemId, updatedOrderData.data);
        
        // If no next item found (e.g., last item was uploaded), find first available item
        if (!nextItemId) {
          nextItemId = findFirstPendingItem(updatedOrderData.data);
        }
        
        if (nextItemId) {
          setActiveItemId(nextItemId);
          scrollToItem(nextItemId);
        }
      } else {
        // Fallback: wait for state update
        setTimeout(() => {
          let nextItemId = findNextPendingItem(itemId);
          
          // If no next item found, find first available item
          if (!nextItemId && order) {
            nextItemId = findFirstPendingItem(order);
          }
          
          if (nextItemId) {
            setActiveItemId(nextItemId);
            scrollToItem(nextItemId);
          }
        }, 300);
      }
    } else {
      setIsSaveAndNext(false);
      console.error("Unexpected response:", response);
      toast.error(
        lang === "ar"
          ? "مرة أخرى حدث خطأ ما! يرجى المحاولة "
          : "Something went wrong! Please try again.",
        {
          icon: false,
          toastId: "required-value-toast6",
          style: {
            color: "#D83D99",
            fontWeight: "700",
          },
        }
      );
    }
  } catch (error) {
    setIsSaveAndNext(false);
    console.error("Save failed:", error.response?.data || error.message);
    // toast.error(
    //   error.response?.data?.message || lang === "ar"
    //     ? "المحاولة مرة أخرى يرجى فشل في حفظ المحتوى "
    //     : "Failed to save content. Please try again.",
    //   {
    //     icon: false,
    //     toastId: "required-value-toast7",
    //     style: {
    //       color: "#D83D99",
    //       fontWeight: "700",
    //     },
    //   }
    // );
    toastErrorMessage(
      error.response?.data?.message || lang === "ar"
        ? "المحاولة مرة أخرى يرجى فشل في حفظ المحتوى "
        : "Failed to save content. Please try again."
    );
  }
   console.log('DEBUG: saveContent completed');
};

  const saveAllContent = async (status) => {
    const formData = {
      answers: uploadContent,
      orderId: order.id,
      status: status,
    };
    const response = await axios.post(
      `${base_url}/api/upload_content/`,
      formData,
      ConfigToken()
    );
    window.location.href = "/dashboard";
  };

  const saveForLater = () => {
    const formData = { answers: uploadContent, orderId: order.id };
    localStorage?.setItem(order.id, JSON.stringify(formData));
    window.location.href = "/dashboard";
  };

const handleChange = (e, id, field, name, idx) => {
  let newValue = field === "file" ? e.target.files[0] : e.target.value;

  // Handle numeric fields (measurements)
  if (field === "height" || field === "length" || field === "width") {
    newValue = newValue.replace(/[^0-9]/g, ""); // Allow only digits
  }

  // Handle text content for Arabic language
  if (field === "content" && lang === "ar" && typeof newValue === "string") {
    // Apply Arabic text processing if available
    newValue = processArabicText ? processArabicText(newValue) : newValue;
  }

  // Handle Arabic name processing
  let processedName = name;
  if (lang === "ar" && typeof name === "string") {
    processedName = processArabicText ? processArabicText(name) : name;
  }

  setUploadContent((prev) => ({
    ...prev,
    [id]: {
      ...prev[id], // Preserve other fields for this ID
      [idx]: {
        ...prev[id]?.[idx],
        [field]: newValue, // Update the file or other field
        ...(field === "file" && { filename: e.target.files[0]?.name || "" }),
        item_sub_name: processedName,
        // Add language context for Arabic content
        ...(lang === "ar" && field === "content" && { language: "ar" }),
      },
    },
  }));
};
  const count = order?.item_details?.bundle_items
    ?.filter(
      (item) => item.item__id !== 76 && (item.status === "in process" || item.status === "pending_content")
    )
    .reduce((total, item) => {
      const missingUploads = Array.from({ length: item.qty }, (_, i) => i + 1)
        .filter((qty) => !(item.uploaded_qty ?? []).includes(qty))
        .filter((qty) => !skipId.includes(`${item.id}_${qty}`));

      return total + missingUploads.length;
    }, 0);

  const addonCount = order?.item_details?.addon_items
    ?.filter((item) => item.status === "in process" || item.status === "pending_content")
    .reduce((total, item) => {
      const missingUploads = Array.from({ length: item.qty }, (_, i) => i + 1)
        .filter((qty) => !(item.uploaded_qty ?? []).includes(qty))
        .filter((qty) => !skipId.includes(`${item.id}_${qty}`));

      return total + missingUploads.length;
    }, 0);

  useEffect(() => {
    if (addonCount + count === 0) {
      navigate(`/dashboard?order_id=${orderId}`);
    }
  }, [skipId, count, addonCount]); // Add all relevant dependencies

  return loading ? (
    <Bgloader />
  ) : (
    <div>
      <div>
        {isSaveAndNext && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              // backgroundColor: "transparent",
              backgroundColor: "rgba(0, 0, 0, 0.4)",

              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              pointerEvents: "auto",
              userSelect: "none",
              zIndex: 9999,
            }}
          >
            {/* <img
              src={ourWorkBranding}
              alt="loader-round-icon"
              style={{ width: 200, height: 200 }}
              className="loader"
            /> */}
            <img className="loader" src={Loader} alt="loader-round-icon"></img>
          </div>
        )}
      </div>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            color: themeColor,
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid ${themeColor}`,
          },
        }}
      />
      <Navbar isLang={lang} setIsLang={setLang} />
      {window.innerWidth <= 475 ? (
        <div className="px-[4%] py-4 font-Helvetica">
          <p
            onClick={() => (window.location.href = "/dashboard")}
            className="flex font-[500] !text-[20px] items-center text-black cursor-pointer"
          >
            {" "}
            <img
              src={backIcon}
              className={`${
                lang === "ar" ? "ml-2 scale-x-[-1]" : "mr-2"
              } w-[30px]`}
            ></img>
            {lang === "ar" ? "العودة إلى لوحة التحكم" : "Back to dashboard"}{" "}
          </p>
          <div className="px-2 lg:mb-0 md:mb-0 xs:mb-[55%]">
            <h3 className="my-4">
              {" "}
              {lang === "ar" ? "تحميل المحتوى" : "Upload Document"}{" "}
            </h3>

            {order && (
              <>
                {" "}
                <Addons
                  order={order}
                  skipId={skipId}
                  uploadFiles={uploadFiles}
                  setUploadFiles={setUploadFiles}
                  lang={lang}
                  designQuestions={designQuestions}
                  uploadContent={uploadContent}
                  handleChange={handleChange}
                  uploadFile={uploadFile}
                  uploadIcon={uploadIcon}
                  setSkipId={setSkipId}
                  saveContent={saveContent}
                  setUploadContent={setUploadContent}
                  isUploading={isUploading}
                  activeItemId={activeItemId}
                />
                <BundlOrder
                  order={order}
                  skipId={skipId}
                  uploadFiles={uploadFiles}
                  setUploadFiles={setUploadFiles}
                  lang={lang}
                  designQuestions={designQuestions}
                  uploadContent={uploadContent}
                  handleChange={handleChange}
                  uploadFile={uploadFile}
                  uploadIcon={uploadIcon}
                  setSkipId={setSkipId}
                  saveContent={saveContent}
                  setUploadContent={setUploadContent}
                  isUploading={isUploading}
                  activeItemId={activeItemId}
                />
              </>
            )}
          </div>

          <div
            style={{
              maxHeight: showDetails ? "600px" : "200px",
              transition: "all 0.5s ease-in-out",
            }}
            className={`fixed bg-white bottom-0 overflow-y-scroll xs:p-[5%_5%_12%_5%] border ${
              showDetails ? "max-h-[80%]" : "h-[200px]"
            } w-full left-0 z-[1]`}
          >
            <div className="bundl-name ">
              <p className="sm:text-[24px] xs:mb-0 xs:flex xs:justify-between sm:block font-[700] px-0 !mb-2   display:flex">
                <span className="font-[400] text-[16px] font-Helvetica">
                  {lang === "ar" ? "قائمه" : "Checklist"}
                </span>
                {isMobile && (
                  <button
                    onClick={() => setDetails(!showDetails)}
                    className="text-[14px] font-[500] underline text-[#1BA56F]"
                  >
                    {!showDetails
  ? lang === "ar" ? "عرض التفاصيل" : "Show Details"
  : lang === "ar" ? "إخفاء التفاصيل" : "Hide Details"
}
                  </button>
                )}
              </p>
            </div>
            {isMobile ? (
              <>
                <div>
                  <div className="!mt-[15px] my-2 w-full">
                    {order && (
                      <div className="px-[5%]">
                        {order.item_details.bundle_items.map(
                          (item, itemIndex) => {
                            if (item.item__id !== 76) {
                              return (
                                <div key={itemIndex}>
                                  {Array.from(
                                    { length: Math.max(1, item.qty) },
                                    (_, qtyIndex) => {
                                      const isUploaded =
                                        !item.uploaded_qty?.includes(
                                          qtyIndex + 1
                                        );
                                      return (
                                        <div
                                          key={`${item.id}_${qtyIndex}`}
                                          className={`flex items-center mb-1 text-[#1BA56F] w-[100%] cursor-pointer ${activeItemId === `${item.id}_${qtyIndex + 1}` ? 'font-bold' : ''}`}
                                          onClick={() => {
                                            const itemId = `${item.id}_${qtyIndex + 1}`;
                                            setActiveItemId(itemId);
                                            const element = document.querySelector(`[data-item-id="${itemId}"]`);
                                            if (element) {
                                              element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                            }
                                          }}
                                        >
                                          <p className="mb-0 font-medium w-[95%]">
                                            {lang === "ar"
                                              ? processArabicText(
                                                  item?.item__name_arabic
                                                )
                                              : item.item_name}{" "}
                                            {item.qty > 1 && qtyIndex + 1}
                                          </p>

                                          {(item.status == "in process" || item.status == "pending_content") &&
                                          isUploaded ? (
                                            // <div className="w-4 h-4 border-2 border-[#1BA56F] rounded-full"></div>
                                            <img
                                              src={checkboxIcon}
                                              width={"26px"}
                                            ></img>
                                          ) : (
                                            <img src={tickCircleIcon}></img>
                                          )}
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              );
                            }
                            return null;
                          }
                        )}

                        {order.item_details.addon_items.map((item) =>
                          Array.from(
                            { length: Math.max(1, item.qty) },
                            (_, qtyIndex) => {
                              const isUploaded = !item.uploaded_qty?.includes(
                                qtyIndex + 1
                              );
                              return (
                                <div 
                                  className={`flex items-center mb-1 text-[#1BA56F] cursor-pointer ${activeItemId === `${item.id}_${qtyIndex + 1}` ? 'font-bold' : ''}`}
                                  onClick={() => {
                                    const itemId = `${item.id}_${qtyIndex + 1}`;
                                    setActiveItemId(itemId);
                                    const element = document.querySelector(`[data-item-id="${itemId}"]`);
                                    if (element) {
                                      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    }
                                  }}
                                >
                                  <div className="flex  w-[100%]">
                                    <p className="mb-0 font-medium w-[95%]">
                                      {" "}
                                      {lang === "ar" ? "إضافات": "Addons"} -{" "}
                                      {lang === "ar"
                                        ? processArabicText(
                                            item?.item__name_arabic
                                          )
                                        : item.item_name}{" "}
                                      {item?.qty > 1 && qtyIndex + 1}
                                    </p>
                                    {(item.status == "in process" || item.status == "pending_content") &&
                                    isUploaded ? (
                                      // <div className="w-4 h-4 border-2 border-[#1BA56F] rounded-full"></div>
                                      <img
                                        src={checkboxIcon}
                                        width={"26px"}
                                      ></img>
                                    ) : (
                                      <img src={tickCircleIcon}></img>
                                    )}
                                  </div>
                                </div>
                              );
                            }
                          )
                        )}
                      </div>
                    )}
                    <div className="border-b-[1px] border-black mt-4"></div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        //  <div className="font-Helvetica flex" style={{ minHeight:"511px" }}>
        <div className="font-Helvet min-h-screen flex">
          <div
            className={`basis-3/4 ${
              lang === "ar" ? "border-l" : "border-r"
            } border-black py-4`}
          >
            <p
              onClick={() => {
                window.location.href = `/dashboard?order_id=${order.id}`;
              }}
              className={`flex cursor-pointer text-[18px] items-center text-black px-4 ${
                lang === "ar"
                  ? "xs:mr-[-4px] sm:mr-[-8px]  lg:mr-[-13px] xl:mr-[0px]"
                  : "xs:ml-[-4px] sm:ml-[-8px]  lg:ml-[-11px] xl:ml-[4px]"
              }`}
            >
              {" "}
              <img
                src={backIcon}
                className={`${lang === "ar" ? "ml-2 scale-x-[-1]" : "mr-2"} `}
              ></img>{" "}
              {lang === "ar" ? "العودة إلى لوحة القيادة" : "Back to dashboard"}{" "}
            </p>
            <div className="">
              <h3 className="my-4 px-[5%]">
                {" "}
                {lang === "ar" ? "تحميل المحتوى" : "Upload Document"}{" "}
              </h3>

              {order && (
                <>
                  <Addons
                    order={order}
                    skipId={skipId}
                    uploadFiles={uploadFiles}
                    setUploadFiles={setUploadFiles}
                    lang={lang}
                    designQuestions={designQuestions}
                    uploadContent={uploadContent}
                    handleChange={handleChange}
                    uploadFile={uploadFile}
                    uploadIcon={uploadIcon}
                    setSkipId={setSkipId}
                    saveContent={saveContent}
                    setUploadContent={setUploadContent}
                    isUploading={isUploading}
                    activeItemId={activeItemId}
                  />

                  <BundlOrder
                    order={order}
                    skipId={skipId}
                    uploadFiles={uploadFiles}
                    setUploadFiles={setUploadFiles}
                    lang={lang}
                    designQuestions={designQuestions}
                    uploadContent={uploadContent}
                    handleChange={handleChange}
                    uploadFile={uploadFile}
                    uploadIcon={uploadIcon}
                    setSkipId={setSkipId}
                    saveContent={saveContent}
                    setUploadContent={setUploadContent}
                    isUploading={isUploading}
                    activeItemId={activeItemId}
                  />
                </>
              )}
            </div>
          </div>
          <div className="basis-1/4 sticky top-0 self-start my-0">
            <div className="border-b border-black my-2 w-[100%]">
              <h3
                className={`mb-0 text-[22px] font-bold py-2 ${
                  lang === "ar" ? "pr-5" : "pl-5"
                }`}
              >
                {lang === "ar" ? "قائمه" : "Checklist"}
              </h3>
            </div>

            <div className={`${lang === "ar" ? "pr-5 pl-0" : "pl-5 pr-0"}`}>
              {order && (
                <>
                  {order?.item_details?.bundle_items?.map((item, itemIndex) => {
                    if (item?.item__id !== 76) {
                      return (
                        <div key={itemIndex}>
                          {Array.from(
                            { length: Math.max(1, item.qty) },
                            (_, qtyIndex) => {
                              const isUploaded = !item?.uploaded_qty?.includes(
                                qtyIndex + 1
                              );
                              return (
                                <div 
                                  className={`flex items-center gap-[10px] mb-1 text-[#1BA56F] cursor-pointer ${activeItemId === `${item.id}_${qtyIndex + 1}` ? 'font-bold' : ''}`}
                                  onClick={() => {
                                    const itemId = `${item.id}_${qtyIndex + 1}`;
                                    setActiveItemId(itemId);
                                    const element = document.querySelector(`[data-item-id="${itemId}"]`);
                                    if (element) {
                                      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    }
                                  }}
                                >
                                  {(item.status == "in process" || item.status == "pending_content") &&
                                  isUploaded ? (
                                    // <div className="w-4 h-4 border-2 border-[#1BA56F] rounded-full"></div>
                                    <img
                                      src={checkboxIcon}
                                      width={"25px"}
                                    ></img>
                                  ) : (
                                    <img src={tickCircleIcon}></img>
                                  )}
                                  <p className="mb-0 font-medium">
                                    {lang === "ar"
                                      ? processArabicText(
                                          item?.item__name_arabic
                                        )
                                      : item.item_name}{" "}
                                    {item?.qty > 1 && qtyIndex + 1}
                                  </p>
                                </div>
                              );
                            }
                          )}
                        </div>
                      );
                    }
                    return null;
                  })}

                  {order.item_details.addon_items.map((item) =>
                    Array.from(
                      { length: Math.max(1, item.qty) },
                      (_, qtyIndex) => {
                        const isUploaded = !item?.uploaded_qty?.includes(
                          qtyIndex + 1
                        );
                        return (
                          <div 
                            className={`flex items-center gap-[10px] mb-1 text-[#1BA56F] cursor-pointer ${activeItemId === `${item.id}_${qtyIndex + 1}` ? 'font-bold' : ''}`}
                            onClick={() => {
                              const itemId = `${item.id}_${qtyIndex + 1}`;
                              setActiveItemId(itemId);
                              const element = document.querySelector(`[data-item-id="${itemId}"]`);
                              if (element) {
                                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                              }
                            }}
                          >
                            {(item.status == "in process" || item.status == "pending_content") &&
                            isUploaded ? (
                              // <div className="w-4 h-4 border-2 border-[#1BA56F] rounded-full"></div>
                              <img src={checkboxIcon} width={"25px"}></img>
                            ) : (
                              <img src={tickCircleIcon}></img>
                            )}
                            <p className="mb-0 font-medium">
                              {lang === "ar"
                                ? processArabicText(item?.item__name_arabic)
                                : item.item_name}{" "}
                              {item?.qty > 1 && qtyIndex + 1}
                            </p>
                          </div>
                        );
                      }
                    )
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {window?.innerWidth >= 500 && (
        <div className="">
          <Footer isLang={lang} />
        </div>
      )}
    </div>
  );
}
